module.exports = "/_next/static/images/DelightYourCustomers@2x-d19daf45bac9907106534cbe6023076c.png";